import students25 from "./twf/students" 
import grades25 from "./twf/grades"
import gazette25 from "./twf/gazette"
import photoAlbum25 from "./twf/photo"
import centers25 from "./twf/centers"

// 2026
import payments26 from "./tws/payments"
import photoAlbum26 from "./tws/photo"
import students26 from "./tws/students"  
import gazette26 from "./tws/gazette"
import centers26 from "./tws/centers"
export default[
    ...students25,
    ...grades25,
    ...gazette25,
    ...photoAlbum25,
    ...centers25,

    // 2026
    ...payments26,
    ...photoAlbum26,
    ...students26,
    ...gazette26,
    ...centers26,

]
